<template>
  <div>
    <div class="orderManage div-layout">
      <module-title title="订单管理">
        <div class="right">
          <el-button type="primary" size="medium" icon="el-icon-plus" @click="handleOrder('add')">
            新增单个订单
          </el-button>
          <el-button type="primary" size="medium" icon="el-icon-upload2" @click="dialogUploadVisible = true">
            批量导入订单
          </el-button>
          <el-button type="primary" size="medium" icon="el-icon-download" @click="handleExport">
            导出
          </el-button>
        </div>
      </module-title>
      <div class="form-box">
        <el-form ref="subjectSearchForm" :model="searchForm" :inline="true" label-position="right" class="subjectSearchForm">
          <el-form-item label="姓名：" prop="teacherName">
            <el-input v-model="searchForm.teacherName" name="teacherName" maxlength="200" placeholder="输入姓名" class="handle-form-input" clearable />
          </el-form-item>
          <el-form-item label="组织名称：" prop="schoolName">
            <el-input v-model="searchForm.schoolName" name="schoolName" maxlength="200" placeholder="输入组织名称" class="handle-form-input" clearable />
          </el-form-item>
          <el-form-item label="下单时间：" prop="time">
            <el-date-picker v-model="searchForm.time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOptions" :clearable="false" />
          </el-form-item>
          <el-form-item label="业务订单号：" prop="orderCode">
            <el-input v-model="searchForm.orderCode" name="orderCode" maxlength="200" placeholder="输入订单号" class="handle-form-input" clearable />
          </el-form-item>
          <el-form-item label="账号类型：" prop="authorizationType">
            <el-select v-model="searchForm.authorizationType" name="authorizationType" size="medium">
              <el-option label="全部" value="" />
              <el-option label="个人" value="99" />
              <el-option v-for="(item,index) in organList" :key="index" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item label="订单状态：" prop="orderStatus">
            <el-select v-model="searchForm.orderStatus" name="orderStatus" size="medium">
              <el-option label="全部" value="" />
              <el-option label="审核不通过" :value="-1" />
              <el-option label="待审核" :value="0" />
              <el-option label="待支付" :value="1" />
              <el-option label="已支付" :value="2" />
              <el-option label="已过期" :value="3" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" icon="el-icon-search" @click="handleSearchFilter">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tab-box">
        <el-table v-loading="listLoading" :data="commodityList" highlight-current-row fit element-loading-text="Loading" class="list-table">
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="业务订单号" prop="orderCode" align="center" width="120">
            <template slot-scope="scope">
              {{ scope.row.orderCode ? scope.row.orderCode:'--' }}
            </template>
          </el-table-column>
          <el-table-column label="支付单号" prop="thirdPaymentCode" align="center" width="120">
            <template slot-scope="scope">
              {{ scope.row.thirdPaymentCode ? scope.row.thirdPaymentCode:'--' }}
            </template>
          </el-table-column>
          <el-table-column label="姓名" prop="teacherName" align="center">
            <template slot-scope="scope">
              {{ scope.row.teacherName ? scope.row.teacherName : '--' }}
            </template>
          </el-table-column>
          <el-table-column label="手机号" prop="teacherPhoneNumber" align="center" width="120">
            <template slot-scope="scope">
              {{ scope.row.teacherPhoneNumber ? scope.row.teacherPhoneNumber : '--' }}
            </template>
          </el-table-column>
          <el-table-column label="授权账号(个)" prop="authorizationQuantity" align="center">
            <template slot-scope="scope">
              {{ scope.row.authorizationQuantity ? scope.row.authorizationQuantity : '--' }}
            </template>
          </el-table-column>
          <el-table-column label="区域" prop="areaName" align="center" width="200">
            <template slot-scope="scope">
              {{ scope.row.provinceName }}-{{ scope.row.cityName }}-{{ scope.row.areaName }}
            </template>
          </el-table-column>
          <el-table-column label="组织名称" prop="schoolName" align="center" width="200">
            <template slot-scope="scope">
              {{ scope.row.schoolName ? scope.row.schoolName : '--' }}
            </template>
          </el-table-column>
          <el-table-column label="授权库存有效期" align="center">
            <template slot-scope="scope">
              {{ scope.row.organizationTypeCode=='99'? '--':scope.row.authorizationActivationTerm+'月' }}
            </template>
          </el-table-column>
          <el-table-column label="账号类型" prop="organizationTypeName" align="center">
            <template slot-scope="scope">
              {{ scope.row.organizationTypeName ? scope.row.organizationTypeName : '--' }}
            </template>
          </el-table-column>
          <el-table-column label="授权开始时间" width="120" prop="authorizationStartTime" align="center">
            <template slot-scope="scope">
              {{ scope.row.authorizationStartTime ? scope.row.authorizationStartTime : '--' }}
            </template>
          </el-table-column>
          <el-table-column label="授权结束时间" width="120" prop="authorizationEndTime" align="center">
            <template slot-scope="scope">
              {{ scope.row.authorizationEndTime ? scope.row.authorizationEndTime : '--' }}
            </template>
          </el-table-column>
          <el-table-column label="授权期限" align="center">
            <template slot-scope="scope">
              {{ scope.row.authorizationTerm ? scope.row.authorizationTerm+'月' : '--' }}
            </template>
          </el-table-column>
          <el-table-column label="商品名称" prop="productName" align="center">
            <template slot-scope="scope">
              {{ scope.row.productName ? scope.row.productName :'--' }}
            </template>
          </el-table-column>
          <el-table-column label="支付时间" prop="paymentFinishTime" align="center" width="150">
            <template slot-scope="scope">
              {{ scope.row.paymentFinishTime ? scope.row.paymentFinishTime :'--' }}
            </template>
          </el-table-column>
          <el-table-column label="支付渠道" prop="paymentChannelName" align="center">
            <template slot-scope="scope">
              {{ scope.row.paymentChannelName ? scope.row.paymentChannelName :'--' }}
            </template>
          </el-table-column>
          <el-table-column label="售价（元）" width="100" prop="productPrice" align="center">
            <template slot-scope="scope">
              {{ scope.row.productPrice ? scope.row.productPrice :'--' }}
            </template>
          </el-table-column>
          <el-table-column label="折扣" prop="discountRate" align="center">
            <template slot-scope="scope">
              {{ scope.row.discountRate ? scope.row.discountRate :'--' }}
            </template>
          </el-table-column>
          <el-table-column label="实付金额（元）" width="120" prop="afterDiscountAmount" align="center">
            <template slot-scope="scope">
              {{ scope.row.afterDiscountAmount ? scope.row.afterDiscountAmount :'--' }}
            </template>
          </el-table-column>
          <el-table-column label="支付凭证" width="120" align="center">
            <template slot-scope="scope">
              <el-image v-if="scope.row.voucherPictureUrl" :src="scope.row.voucherPictureUrl" :preview-src-list="[scope.row.voucherPictureUrl]" style="width:100px;height:60px" fit="cover" />
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="订单状态" width="120" prop="orderStatusName" align="center" />
          <el-table-column label="操作" align="center" width="200px">
            <template slot-scope="scope">
              <span v-if="(scope.row.orderStatus===-1 || scope.row.orderStatus===1) && scope.row.organizationTypeCode != '99'">
                <el-button type="danger" size="small" @click="handleInvalid(scope.row)">作废</el-button>
                <el-button type="primary" size="small" icon="el-icon-edit" @click="handleOrder('edit',scope.row)">编辑</el-button>
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination :total="pageObj.total" :page.sync="pageObj.pageNum" :limit.sync="pageObj.pageSize" @pagination="pageCurriculumList" @handleSizeChange="handleSizeChange" />
      </div>
      <!-- 新增/编辑 -->
      <el-dialog v-if="dialogAddOrEditVisible" :close-on-click-modal="false" :visible.sync="dialogAddOrEditVisible" :title="dialogTitle" width="700px">
        <addOrEdit :order-id="orderId" @closeDialog="closeDialog" @getTableList="fetchCommodity" />
      </el-dialog>
      <!-- 导入数据 -->
      <el-dialog v-if="dialogUploadVisible" :close-on-click-modal="false" :visible.sync="dialogUploadVisible" title="批量导入订单">
        <el-form label-position="right" label-width="120px">
          <el-form-item label="导入说明：" prop="">
            <span>订单表格和支付凭证图片需要分离，放置在一个文件夹中进行压缩打包上传，支付凭证图片名称需与业务订单号一致</span>
          </el-form-item>
          <el-form-item label="导入模板：" prop="">
            <div class="donwload-box">
              <el-upload
                ref="upload"
                :multiple="false"
                :limit="1"
                :on-success="onSuccess"
                :action="uploadUrl"
                :headers="uploadHeader"
                :on-progress="onProgress"
                :on-error="onError"
                name="file"
                accept=".zip"
                class="handle-btn"
              >
                <el-button type="primary" style=" margin-bottom: 20px;margin-right:30px" icon="el-icon-upload2" size="medium" @click="handlerExcelTemplate">
                  下载模板
                </el-button>
                <el-button :loading="fileUploading" size="medium" type="primary" icon="el-icon-upload2">
                  {{ fileUploading?'上传文件中...':'上传文件' }}
                </el-button>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="dialogUploadVisible=false">
            取消
          </el-button>
          <el-button type="primary" size="medium" @click="dialogUploadVisible=false">
            确认
          </el-button>
        </div>
      </el-dialog>
      <!-- 异常数据 -->
      <el-dialog v-if="dialogMultipleImportVisible" :close-on-click-modal="false" :visible.sync="dialogMultipleImportVisible" title="异常数据">
        <p style="padding:0 0 20px 20px;">
          导入失败，存在{{ abnormalDataList.length }}条异常记录，请修改后重新上传
        </p>
        <el-scrollbar wrap-class="abnormal-table">
          <el-table :data="abnormalDataList" fit highlight-current-row>
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="报错行" prop="errorMsg" align="center">
              <template slot-scope="scope">
                <span class="red">{{ scope.row.errRow }}</span>
              </template>
            </el-table-column>
            <el-table-column label="异常原因" prop="errorMsg" align="center">
              <template slot-scope="scope">
                <span class="red">{{ scope.row.errorMsg }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import addOrEdit from './addOrEdit';
import { getNowFormatDate, getupFormatDate } from '@/utils/index';
import { getProductsPagelist, invalid, ordersExport } from '@/api/yzdPlatformManage/userManage.js';
import { deepCopy } from '@/utils/index.js';
import { exportOrgOrdersTempate, importOrders, getOrganizationsTypes } from '@/api/yzdPlatformManage/orderManage';
import { getToken } from '@/utils/auth';
export default {
  components: { addOrEdit },
  data() {
    return {
      organList: [],
      fileUploading: false,
      searchForm: {
        authorizationEndTime: '',
        authorizationStartTime: '',
        authorizationType: '',
        frontOrderStatus: '',
        orderStatus: '',
        status: '',
        schoolName: '',
        teacherName: '',
        time: [getupFormatDate(null, null, 3), getNowFormatDate()]
      },
      pageObj: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      listLoading: false, // 表格刷新loading
      commodityList: [],
      datePickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.searchForm.authorizationStartTime = minDate.getTime();
          if (maxDate) {
            this.searchForm.authorizationStartTime = '';
          }
        },
        disabledDate: (time) => {
          const one = 3 * 30 * 24 * 3600 * 1000;
          const minTime = this.searchForm.authorizationStartTime;
          if (this.searchForm.authorizationStartTime !== '') {
            let maxTime = this.searchForm.authorizationStartTime + one;
            if (maxTime > new Date()) {
              maxTime = new Date();
            }
            return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now() - 8.64e6;
          } else {
            return time.getTime() > Date.now() - 8.64e6;
          }
        }
      },
      orderId: '',
      dialogAddOrEditVisible: false,
      dialogTitle: '',
      dialogUploadVisible: false,
      dialogMultipleImportVisible: false,
      abnormalDataList: [],
      uploadUrl: '',
      uploadHeader: {}, // 上传文件上传头
      getOrganizationsTypes: []
    };
  },
  mounted() {
    this.fetchCommodity();
    this.initUploadData();
    this.getTypes();
  },
  methods: {
    // 获取积分明细数据
    fetchCommodity() {
      this.listLoading = true;
      getProductsPagelist({ ...this.option, pageNum: this.pageObj.pageNum, pageSize: this.pageObj.pageSize }).then((res) => {
        if (res.data && res.data.list && res.data.list.length) {
          this.commodityList = res.data.list;
          this.pageObj.total = res.data.total;
        } else {
          this.commodityList = [];
          this.pageObj.total = 0;
        }
        this.listLoading = false;
      }).catch((err) => {
        console.log(err);
        this.commodityList = [];
        this.pageObj.total = 0;
        this.listLoading = false;
      });
    },
    // 分页
    pageCurriculumList(obj) {
      this.pageObj.pageNum = obj.page;
      this.fetchCommodity();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.pageObj.pageNum = 1;
      this.pageObj.pageSize = obj.limit;
      this.fetchCommodity();
    },
    // 条件查询
    handleSearchFilter() {
      this.pageObj.pageNum = 1;
      this.pageObj.pageSize = 10;
      this.option = {
        orderCreateStartTime: this.searchForm.time[0],
        orderCreateEndTime: this.searchForm.time[1],
        orderCode: this.searchForm.orderCode || null,
        orderStatus: this.searchForm.orderStatus || null,
        organizationTypeCode: this.searchForm.authorizationType || null,
        authorizationStatus: this.searchForm.authorizationStatus || null,
        organizationName: this.searchForm.schoolName || null,
        organizationAdminName: this.searchForm.teacherName || null
      };
      this.fetchCommodity();
    },
    // 作废
    handleInvalid(row) {
      this.$confirm('是否作废此次申请？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        invalid({ id: row.orderId }).then(() => {
          this.$message({ type: 'success', message: '订单已作废!' });
          this.fetchCommodity();
        });
      }).catch(() => {
        // this.$message({ type: 'info', message: '已取消返回!' });
      });
    },
    // 导出
    handleExport() {
      const op = deepCopy(this.searchForm);
      delete op.time;
      window.location.href = ordersExport(op);
    },
    // 操作
    handleOrder(type, row) {
      if (type === 'add') {
        this.dialogTitle = '新增订单';
        this.orderId = '';
      } else {
        this.dialogTitle = '编辑订单';
        this.orderId = row.orderId;
      }
      this.dialogAddOrEditVisible = true;
    },
    // 关闭新增/编辑
    closeDialog() {
      this.dialogAddOrEditVisible = false;
    },
    // 下载模板
    handlerExcelTemplate() {
      window.location.href = exportOrgOrdersTempate();
    },
    // 初始化上传数据
    initUploadData() {
      const accessToken = getToken();
      this.uploadHeader = {
        Authorization: `Bearer ${accessToken}`
      };
      this.uploadUrl = importOrders(); // 导入
    },
    // 导入 加载
    onProgress() {
      this.fileUploading = true;
    },
    onError() {
      this.fileUploading = false;
      this.$message({ message: '文件上传失败', type: 'error' });
    },
    // 导入上传成功
    onSuccess(response, file, fileList) {
      this.fileUploading = false;
      this.$refs.upload.clearFiles();
      if (response.code === '0') {
        this.$message({ message: '文件上传成功', type: 'success' });
        this.fetchCommodity();
        this.dialogUploadVisible = false;
      } else {
        if (response.data) {
          this.dialogMultipleImportVisible = true;
          this.abnormalDataList = [];
          const list = response.data;
          list.forEach(v => {
            this.abnormalDataList.push({ errRow: v.row, errorMsg: v.msg });
          });
        } else {
          this.$message({ message: response.message, type: 'error' });
          this.abnormalDataList = [];
        }
      }
    },
    getTypes() {
      getOrganizationsTypes().then(res => {
        if (res.code === '0') {
          this.organList = res.data;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.orderManage{
    .form-box{
        padding: 0 30px;
    }
    .donwload-box{
      display: flex;
      justify-content: flex-start;
    }
    .red{
      color: red;
    }
}
</style>
